<label for="addToCatalog" class="reactive-forms__label-checkbox">
  <input
    id="addToCatalog"
    df-checkbox
    [checked]="addToCatalog"
    type="checkbox"
    name="addToCatalog"
    formControlName="addToCatalog"
  />
  <span class="guts-m-l-half">{{
    'addToPathwayModal_AddToCatalog' | translate
  }}</span></label
>
